/**
 * Zühre Ana - product page behaviour: pack selector, order help, "Se potrivește bine cu".
 * Vanilla JS (ES5), no dependencies. Loaded with defer by sections/main-product.liquid.
 *
 * 1. PACK SELECTOR - how the pack cards talk to the Kalles theme (assets/swatch.min.js):
 * - The theme binds a delegated click on ".swatches-select > .nt-swatch" inside the product form.
 *   That handler picks the variant, writes it to select[name="id"] and runs the theme's
 *   selectCallback(), which updates price, add to cart, buy now, sticky bar, gallery image and URL,
 *   then fires jQuery_T4NT(document).trigger('variant:change', variant).
 * - The theme's swatches stay in the DOM (visually hidden in .za-pack-native). Choosing a card
 *   simply clicks the matching swatch, so the theme does all the work with its own code.
 * - The checked card follows the theme through the 'variant:change' event and, as a safety net,
 *   a MutationObserver on the swatch list (covers changes started by the gallery or before
 *   jQuery is available).
 * - The theme's variant code starts late (its product data is lazy loaded on scroll). If a card is
 *   chosen before it starts, the choice is stored on the swatch with the class the theme clicks on
 *   start-up (.is-selected-nt) and written to select[name="id"], so the right pack is added to the
 *   cart either way, and the theme's lazy loader is asked to fetch the product data at once.
 * - URL: this shop runs the theme with "enable history state" off (settings.enable_his), so the
 *   theme leaves the address unchanged. Once the customer has picked a card, this script keeps
 *   ?variant=ID in the address itself (replaceState, same as the theme would do).
 * - If anything here fails, html.za-no-pack hides the cards and shows the theme's swatches again.
 *
 * 2. ORDER HELP - the WhatsApp link works without this file; here the message only gets the chosen
 *    pack and quantity just before the link is followed.
 *
 * 3. "SE POTRIVEȘTE BINE CU" - the rows come from sections/za-complementary.liquid through Shopify's
 *    product recommendations endpoint (intent=complementary, then intent=related). The box is shown
 *    only when there are rows and only while it is off screen (or in space reserved by the CSS), so
 *    nothing on screen moves. "Adaugă" posts to /cart/add.js with sections=cart_js and hands the
 *    answer to the theme's own geckoShopify.onCartUpdate(), which repaints the mini cart and runs
 *    the shop's "after add to cart" action (opens the cart drawer). If the theme script is not
 *    available the customer is taken to the cart page instead.
 */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;

  if (window.zaProduct) {
    window.zaProduct.init(doc);
    return;
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function closest(node, selector) {
    if (node.closest) {
      return node.closest(selector);
    }
    var matches = node.matches || node.msMatchesSelector || node.webkitMatchesSelector;
    while (node && node.nodeType === 1) {
      if (matches.call(node, selector)) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  /* ------------------------------------------------------------------
     1. Pack selector
     ------------------------------------------------------------------ */

  // True once the customer has picked a card; from then on the address follows the variant.
  var userPicked = false;

  function updateUrl(variantId) {
    if (!userPicked || !window.history || !window.history.replaceState || typeof window.URL !== 'function') {
      return;
    }
    try {
      var url = new window.URL(window.location.href);
      if (url.searchParams.get('variant') === String(variantId)) {
        return;
      }
      url.searchParams.set('variant', variantId);
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (error) {
      // Address stays as it is; nothing else depends on it.
    }
  }

  function initPack(pack) {
    if (pack.zaPackReady) {
      return;
    }

    var form = closest(pack, 'form');
    var select = form ? form.querySelector('select[name="id"]') : null;
    var native = form ? form.querySelector('.za-pack-native') : null;
    var list = native ? native.querySelector('.swatches-select') : null;
    var inputs = toArray(pack.querySelectorAll('.za-pack__input'));

    if (!select || !list || !inputs.length) {
      throw new Error('za-pack: theme variant markup not found');
    }

    var swatches = toArray(list.children);

    // One card <-> one native swatch, matched on the raw option value.
    var pairs = inputs.map(function (input) {
      var value = input.getAttribute('data-value');
      var match = null;
      swatches.forEach(function (swatch) {
        if (swatch.getAttribute('data-escape') === value) {
          match = swatch;
        }
      });
      if (!match) {
        throw new Error('za-pack: no theme swatch for "' + value + '"');
      }
      return { input: input, swatch: match };
    });

    function swatchFor(input) {
      for (var i = 0; i < pairs.length; i++) {
        if (pairs[i].input === input) {
          return pairs[i].swatch;
        }
      }
      return null;
    }

    function currentSwatch() {
      return list.querySelector('.nt-swatch.is-selected') || list.querySelector('.nt-swatch.is-selected-nt');
    }

    // Theme -> cards.
    function syncFromTheme() {
      var current = currentSwatch();
      if (!current) {
        return;
      }
      pairs.forEach(function (pair) {
        if (pair.swatch === current && !pair.input.checked) {
          pair.input.checked = true;
        }
      });
    }

    // The theme reads the product data lazily: its placeholder (.nt_pr_js) is fetched by the theme's
    // lazy loader (window.lazySizesT4) only when it comes close to the screen, and the variant code
    // starts after that. A customer who picks a pack earlier should not have to scroll first, so the
    // loader is asked to fetch it now. The "lazyloadt4s" class is the proof that swatch.min.js has
    // already attached its start-up listener to the placeholder and that it has not been fetched yet.
    function wakeTheme() {
      var holder = form.querySelector('.nt_pr_js');
      var lazy = window.lazySizesT4;
      if (!holder || !holder.classList.contains('lazyloadt4s') || !lazy || !lazy.loader || typeof lazy.loader.unveil !== 'function') {
        return;
      }
      try {
        lazy.loader.unveil(holder);
      } catch (error) {
        // The loader still fetches it on scroll, as before.
      }
    }

    // Cards -> theme.
    function choose(input) {
      var swatch = swatchFor(input);
      if (!swatch) {
        return;
      }
      if (!swatch.classList.contains('is-selected')) {
        if (!list.querySelector('.is-selected')) {
          // Theme script not started yet (or nothing picked so far): mark this swatch the way
          // the theme expects its start-up selection, so it begins from the chosen pack.
          toArray(list.querySelectorAll('.is-selected-nt')).forEach(function (item) {
            item.classList.remove('is-selected-nt');
          });
          swatch.classList.add('is-selected-nt');
          wakeTheme();
        }
        swatch.click();
      }
      // Safety net: if the theme did not handle the click, still post the chosen pack.
      if (select.value !== input.value) {
        select.value = input.value;
      }
      updateUrl(input.value);
    }

    pack.addEventListener('change', function (event) {
      var input = event.target;
      if (input && input.checked && swatchFor(input)) {
        userPicked = true;
        choose(input);
      }
    });

    if ('MutationObserver' in window) {
      new MutationObserver(syncFromTheme).observe(list, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
    }

    // A card tapped before this script was ready wins; otherwise follow the theme's state.
    var early = pack.querySelector('.za-pack__input:checked:not(:disabled)');
    if (early && swatchFor(early) !== currentSwatch()) {
      userPicked = true;
      choose(early);
    } else {
      syncFromTheme();
    }

    // The cards now speak for the hidden swatches.
    native.setAttribute('aria-hidden', 'true');
    pack.zaPackReady = true;
  }

  // Theme hook: fired by swatch.min.js at the end of every variant change.
  function onThemeVariantChange(event, variant) {
    if (!variant || !variant.id) {
      return;
    }
    var id = String(variant.id);
    toArray(doc.querySelectorAll('.za-pack__input')).forEach(function (input) {
      if (input.value !== id) {
        return;
      }
      if (!input.checked) {
        input.checked = true;
      }
      // Also covers variant changes started from the gallery.
      updateUrl(id);
    });
  }

  function bindThemeEvent(attempt) {
    var $ = window.jQuery_T4NT;
    if ($ && $.fn && typeof $.fn.on === 'function') {
      $(doc).off('variant:change.zaPack').on('variant:change.zaPack', onThemeVariantChange);
      return;
    }
    if (attempt < 40) {
      window.setTimeout(function () {
        bindThemeEvent(attempt + 1);
      }, 250);
    }
  }

  /* ------------------------------------------------------------------
     2. Order help: add the chosen pack and quantity to the WhatsApp message
     ------------------------------------------------------------------ */

  function initWhatsApp(link) {
    if (link.zaReady) {
      return;
    }
    var base = link.getAttribute('data-za-base');
    var text = link.getAttribute('data-za-text');
    var url = link.getAttribute('data-za-url') || '';
    if (!base || !text) {
      return;
    }
    link.zaReady = true;

    function refresh() {
      var scope = closest(link, '.btn-atc') || doc;
      var message = text;
      var target = url;
      var packOn = !root.classList.contains('za-no-pack');
      var picked = packOn ? scope.querySelector('.za-pack__input:checked') : null;
      var qtyInput = scope.querySelector('.quantity input.qty');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      if (picked) {
        message += ' – ' + picked.getAttribute('data-label');
        if (target) {
          target += (target.indexOf('?') === -1 ? '?' : '&') + 'variant=' + picked.value;
        }
      }
      if (qty > 1) {
        message += ', cantitate: ' + qty;
      }
      link.href = base + '?text=' + encodeURIComponent(message + (target ? '\n' + target : ''));
    }

    // Refreshed just before the link is followed (tap, click, keyboard, long press).
    ['pointerdown', 'focus', 'click'].forEach(function (type) {
      link.addEventListener(type, refresh);
    });
  }

  /* ------------------------------------------------------------------
     3. "Se potrivește bine cu": recommended products under the buy area
     ------------------------------------------------------------------ */

  var COMP_TEXT = {
    add: 'Adaugă',
    adding: 'Se adaugă…',
    added: 'Adăugat',
    addedStatus: 'Produsul a fost adăugat în coș.',
    error: 'Produsul nu a putut fi adăugat în coș. Te rugăm să încerci din nou.'
  };

  function requestCompRows(box, intent) {
    var url = box.getAttribute('data-url') +
      '?section_id=' + encodeURIComponent(box.getAttribute('data-section') || 'za-complementary') +
      '&product_id=' + encodeURIComponent(box.getAttribute('data-product-id')) +
      '&limit=' + encodeURIComponent(box.getAttribute('data-limit') || '6') +
      '&intent=' + intent;

    return window.fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('za-comp: ' + response.status);
        }
        return response.text();
      })
      .then(function (html) {
        // Parsed in a detached element: nothing is requested or run until the rows are used.
        var holder = doc.createElement('div');
        holder.innerHTML = html;
        var list = holder.querySelector('[data-za-comp-list]');
        return list && list.children.length ? list : null;
      });
  }

  // Shows the filled box without moving anything the customer is looking at.
  function showComp(box, panel, attempt) {
    function show() {
      panel.hidden = false;
      box.classList.add('za-comp--ready');
    }

    var view = window.innerHeight || root.clientHeight || 0;
    var rect = box.getBoundingClientRect();
    var rendered = rect.width > 0 || rect.height > 0 || rect.top !== 0;

    // Not rendered at all or below the fold: nothing that is visible moves.
    if (!rendered || rect.top >= view) {
      show();
      return;
    }

    // Sitting in space the CSS reserved for it (tall desktop screens): fill it in place and keep
    // the reserved height, so a short list does not pull the content below it upwards.
    if (rect.height > 40) {
      box.classList.add('za-comp--held');
      show();
      return;
    }

    // Already scrolled past: the page grows above the visible part. Browsers with scroll
    // anchoring keep the view still by themselves; the others are corrected here.
    if (rect.bottom <= 0) {
      var anchored = !!(window.CSS && window.CSS.supports && window.CSS.supports('overflow-anchor', 'auto'));
      var before = root.scrollHeight;
      show();
      var grown = root.scrollHeight - before;
      if (!anchored && grown > 0) {
        if ('scrollBehavior' in root.style) {
          window.scrollBy({ top: grown, left: 0, behavior: 'instant' });
        } else {
          window.scrollBy(0, grown);
        }
      }
      return;
    }

    // On screen right now: wait until the customer has scrolled it out of view.
    if (!('IntersectionObserver' in window) || attempt > 3) {
      show();
      return;
    }
    var observer = new window.IntersectionObserver(function (entries) {
      if (entries[entries.length - 1].isIntersecting) {
        return;
      }
      observer.disconnect();
      showComp(box, panel, attempt + 1);
    });
    observer.observe(box);
  }

  function initComp(box) {
    if (box.zaCompReady) {
      return;
    }
    box.zaCompReady = true;

    var panel = box.querySelector('[data-za-comp-box]');
    var rows = box.querySelector('[data-za-comp-rows]');

    function empty() {
      box.classList.add('za-comp--empty');
    }

    if (!panel || !rows || !window.fetch || !box.getAttribute('data-url') || !box.getAttribute('data-product-id')) {
      empty();
      return;
    }

    requestCompRows(box, 'complementary')
      .then(null, function () {
        return null;
      })
      .then(function (list) {
        return list || requestCompRows(box, 'related');
      })
      .then(function (list) {
        if (!list) {
          empty();
          return;
        }
        rows.appendChild(list);
        showComp(box, panel, 0);
      })
      .then(null, empty);
  }

  // Theme hook (assets/swatch.min.js): geckoShopify.onCartUpdate(openAfter, refreshItems, html)
  // repaints the mini cart from the rendered "cart_js" section and then runs the shop's
  // "after add to cart" action; without a product id that action opens the cart drawer.
  // The theme also announces every add with a "CartUpdateSuccess" event on <body>; it is
  // repeated here so anything listening for it sees this add as well.
  function refreshThemeCart(data, cartUrl) {
    var theme = window.geckoShopify;
    var html = data && data.sections ? data.sections.cart_js : null;
    var painted = false;
    if (theme && typeof theme.onCartUpdate === 'function' && typeof html === 'string' && html.indexOf('[split_t4nt0]') !== -1) {
      try {
        theme.onCartUpdate(1, 1, html);
        painted = true;
      } catch (error) {
        // Falls through to the cart page.
      }
    }
    if (!painted) {
      window.location.href = cartUrl || '/cart';
      return;
    }
    try {
      var $ = window.jQuery_T4NT;
      if ($ && doc.body) {
        $(doc.body).trigger('CartUpdateSuccess');
      }
    } catch (error) {
      // The cart is already up to date; the extra event is optional.
    }
  }

  function onCompSubmit(event) {
    var form = event.target;
    if (!form || !form.getAttribute || form.getAttribute('data-za-comp-form') === null) {
      return;
    }
    var box = closest(form, '.za-comp[data-za-comp]');
    var button = form.querySelector('[data-za-comp-add]');
    var label = form.querySelector('[data-za-comp-txt]');
    var idInput = form.querySelector('input[name="id"]');
    var addUrl = box ? box.getAttribute('data-add-url') : null;

    // Anything missing: let the form post normally (the customer lands on the cart page).
    if (!box || !button || !label || !idInput || !addUrl || !window.fetch) {
      return;
    }
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') {
      return;
    }

    var errorBox = form.querySelector('[data-za-comp-error]');
    var status = box.querySelector('[data-za-comp-status]');

    function setState(state, text) {
      button.classList.remove('is-loading', 'is-done');
      if (state) {
        button.classList.add(state);
      }
      if (state === 'is-loading') {
        button.setAttribute('aria-busy', 'true');
      } else {
        button.removeAttribute('aria-busy');
      }
      label.textContent = text;
    }

    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }
    if (status) {
      status.textContent = '';
    }
    setState('is-loading', COMP_TEXT.adding);

    window.fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(idInput.value, 10), quantity: 1 }],
        sections: 'cart_js'
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data || {} };
        });
      })
      .then(function (result) {
        var data = result.data;
        if (!result.ok || (data.status && data.status !== 200)) {
          var failure = new Error(data.description || data.message || '');
          failure.zaFromShop = true;
          throw failure;
        }
        setState('is-done', COMP_TEXT.added);
        if (status) {
          status.textContent = COMP_TEXT.addedStatus;
        }
        window.setTimeout(function () {
          setState('', COMP_TEXT.add);
        }, 2500);
        refreshThemeCart(data, box.getAttribute('data-cart-url'));
      })
      .then(null, function (error) {
        setState('', COMP_TEXT.add);
        if (errorBox) {
          // Shopify explains stock problems in the shop language; anything else gets a plain sentence.
          errorBox.textContent = error && error.zaFromShop && error.message ? error.message : COMP_TEXT.error;
          errorBox.hidden = false;
        }
      });
  }

  /* ------------------------------------------------------------------
     Start
     ------------------------------------------------------------------ */

  function init(scope) {
    scope = scope && scope.querySelectorAll ? scope : doc;

    // Class + attribute on purpose: other scripts of this shop also use "data-za-*" attributes
    // (the cart drawer puts data-za-pack on its own buttons), and those must never be picked up here.
    var packs = toArray(scope.querySelectorAll('.za-pack[data-za-pack]'));
    packs.forEach(function (pack) {
      try {
        initPack(pack);
      } catch (error) {
        root.classList.add('za-no-pack');
      }
    });
    if (packs.length) {
      bindThemeEvent(0);
    }

    toArray(scope.querySelectorAll('.za-help [data-za-wa]')).forEach(initWhatsApp);

    toArray(scope.querySelectorAll('.za-comp[data-za-comp]')).forEach(function (box) {
      try {
        initComp(box);
      } catch (error) {
        box.classList.add('za-comp--empty');
      }
    });
  }

  window.zaProduct = { init: init };

  doc.addEventListener('submit', onCompSubmit);

  init(doc);

  // Theme editor: the section is re-rendered in place.
  doc.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
